<template>
  <div class="document-container">
    <div class="columns is-desktop">
      <div class="column">
        <split-id/>
      </div>
      <div class="column is-3">
        <quick-tips-split-id/>
      </div>
    </div>
  </div>
</template>

<script>
import SplitId from '@/components/ID Manager Components/SplitId.vue';
import QuickTipsSplitId from '@/components/ID Manager Components/QuickTipsSplitId.vue';

export default {
  components: {
    SplitId,
    QuickTipsSplitId,
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
    padding: 0.5rem !important
</style>
